<template>
  <div class="control">
    <div class="control__title">
      <div class="title">
        <div class="title-text">
          {{ title }}
        </div>
        <div class="control__helper">
          <div class="control__trigger" @mouseover="showHint = true" @mouseleave="showHint = false">
            <img src="https://sirv.sirv.com/website/theme2/icon/question.svg" :alt="hint" />
          </div>
          <div v-show="showHint" class="hint">
            {{ hint }}
          </div>
        </div>
      </div>
    </div>
    <div class="control__action">
      <div class="control__choice">
        <div
          v-show="!selectStatus"
          class="fakeoverlay"
          :class="{ disabled: !selectStatus }"
          @click="selectStatus = !selectStatus"
        />
        <el-input-number
          v-model.number="value1"
          controls-position="right"
          :min="min"
          :max="max"
          type="number"
          :step="step"
          :disabled="!selectStatus"
          class="padding_custom"
          @change="changeOption"
        />
        <el-input-number
          v-model.number="value2"
          controls-position="right"
          :min="min"
          :max="max"
          type="number"
          :step="step"
          :disabled="!selectStatus"
          class="padding_custom"
          @change="changeOption"
        />
        <el-input-number
          v-model.number="value3"
          controls-position="right"
          :min="min"
          :max="max"
          type="number"
          :step="step"
          :disabled="!selectStatus"
          class="padding_custom"
          @change="changeOption"
        />
        <el-select
          v-model="valueSelect"
          class="control__select"
          :disabled="!selectStatus"
          placeholder="false"
          @change="changeOption"
        >
          <el-option
            v-for="(select, index) in selectOption"
            :key="index"
            :label="select.value"
            :value="select.value"
          />
        </el-select>
      </div>
      <el-checkbox v-model="selectStatus" class="control__checkbox" @change="changeOption" />
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "NumberInputThreeSelect",
  props: {
    title: {
      type: String,
      default: "",
    },
    default1: {
      type: [Number, String],
      default: 0,
    },
    default2: {
      type: [Number, String],
      default: 0,
    },
    default3: {
      type: [Number, String],
      default: 0,
    },
    hint: {
      type: String,
      default: "",
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 0,
    },
    status: {
      type: Boolean,
    },
    parameter: {
      type: String,
      default: "",
    },
    eventClick: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: Function,
    },
    valueselectdefault: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      value1: this.default1,
      value2: this.default2,
      value3: this.default3,
      selectStatus: this.status,
      showHint: false,
      selectOption: this.options,
      valueSelect: this.valueselectdefault,
    };
  },
  emits: ["changeOption"],
  computed: {
    ...mapState(["clearOptions", "settings"]),
  },
  watch: {
    clearOptions(value) {
      if (value) {
        this.selectStatus = false;
        this.value1 = this.default1;
        this.value2 = this.default2;
        this.value3 = this.default3;
        this.valueSelect = this.valueselectdefault;
      }
    },
    eventClick(val) {
      this.selectStatus = val;
      this.value1 = this.default1;
      this.value2 = this.default2;
      this.value3 = this.default3;
      this.valueSelect = this.valueselectdefault;
    },
    selectStatus(val) {
      if (val === true) {
        this.changeOption();
      }
    },
  },
  methods: {
    changeOption() {
      let value = '';
   
      this.value1 = String(this.value1 ?? this.default1);
      this.value2 = String(this.value2 ?? this.default2);
      this.value3 = String(this.value3 ?? this.default3);
      this.valueSelect = this.valueSelect ?? this.valueselectdefault;

      if (this.parameter === 'camera.orbit') {
        if (this.selectStatus) {
          value = `${this.value1}deg ${this.value2}deg ${this.value3}%`;
        } else {
          value = `${this.default1}deg ${this.default2}deg ${this.default3}%`;
        }
      } else if (this.parameter === 'camera.target') {
        if (this.selectStatus) {
          value = `${this.value1} ${this.value2} ${this.value3}`;
        } else {
          value = `0 0 0`;
        }
      } else {
        value = this.selectStatus === true
          ? `${this.value1}${this.valueSelect} ${this.value2}${this.valueSelect} ${this.value3}${this.valueSelect}`
          : "";
      }

      this.$emit("changeOption", {
        parameter: `${this.parameter}`,
        separator: ":",
        value: value,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.control__choice {
  display: flex;
}

.control__select {
  width: 100px;
}

.el-input-number {
  width: 35% !important;
}
</style>
<style lang="scss">
.el-input-number.is-controls-right {
  max-width: 100%;
  width: 100%;
  .el-input__inner {
    text-align: left !important;
  }
}
.el-input-number__decrease,
.el-input-number__increase {
  width: 25px !important;
}

.padding_custom .el-input .el-input__inner {
  padding-left: 10px !important;
  padding-right: 35px !important;
}
.el-input-number[data-v-54b425a3] .el-input__inner {
  padding-left: 10px !important;
  padding-right: 35px !important;
}
</style>
